<div class="app-studio studio-player">
	<router-outlet></router-outlet>
</div>
